<template>
  <div id="container" class="cs_st grid-container">
    <BaseLocation current-group-name="serviceCenter" />

    <!--QNA-->
    <div class="section fill">
      <div class="inner">
        <h2>{{ $t('views.help.events.4447') }}</h2>
        <p class="sub">{{ $t('views.help.events.9278') }}</p>
        <!-- Tab START -->
        <div class="link_tab event">
          <ul>
            <li :class="{ active: search === 'CE' }">
              <a class="link_tab_menu" @click="selectActiveTab('CE')">{{
                $t('views.help.events.1186')
              }}</a>
            </li>
            <li :class="{ active: search === 'PE' }">
              <a class="link_tab_menu" @click="selectActiveTab('PE')">{{
                $t('views.help.events.7264')
              }}</a>
            </li>
          </ul>
        </div>
        <!-- Tab END -->

        <template v-if="!showDetail">
          <div v-if="getEvents" class="tab_detail">
            <div class="tab_page" data-tab-content="tab-event-now">
              <ul class="event_list">
                <li
                  v-for="(event, idx) in formattedEvents"
                  :key="idx"
                  class="event_item"
                >
                  <a class="evnet_item_wrap" @click="showEventDetail(event)"
                    ><div class="event_image_wrap">
                      <img :src="event.thumbUrl" />
                    </div>
                    <div class="event_meta_wrap">
                      <p class="evt_title base_NR20">
                        {{ event.eventNm || '이벤트 타이틀' }}
                      </p>
                      <div class="evt_date">
                        <p class="base_MT14">
                          {{ event.fromDtime }} ~ {{ event.toDtime }}
                        </p>
                      </div>
                      <!-- eslint-disable-next-line vue/no-v-html -->
                      <p class="event_sub_desc" v-html="event.eventDesc"></p>
                    </div>
                  </a>
                  <!-- <a
                    class="sec_title quarter_mobile_cs"
                    @click="showEventDetail(event)"
                    ><img :src="event.thumbUrl" :alt="event.eventTitle"
                  /></a> -->
                </li>
              </ul>
            </div>
          </div>
          <EmptyData v-else data-tp="이벤트" />

          <pagination
            v-if="getEvents"
            :current-page="currentPage"
            :total-count="getEventTotalCount"
            :item-per-page="eventsPerPage"
            @paginate="paginate"
          />
        </template>

        <template v-if="showDetail && currentEvent">
          <div class="event_detail">
            <div class="tit">
              <p class="txt">{{ currentEvent.eventNm }}</p>
              <span class="num date"
                >{{ currentEvent.fromDtime || '0000-00-00' }} ~
                {{ currentEvent.toDtime || '0000-00-00' }}</span
              >
            </div>
            <div class="cont">
              <!-- <img
                :src="currentEvent.thumbUrl"
                :alt="`${currentEvent.eventNm}`"
              /> -->
              <!-- eslint-disable-next-line vue/no-v-html -->
              <p v-html="currentEvent.eventDesc"></p>
            </div>
            <div class="btn_wrap tac">
              <button type="summit" class="box_btn" @click="showEventDetail()">
                <span class="an_t"><a>목록</a></span>
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- <transition name="slide-right"> -->
    <Sidebar />
    <!-- </transition> -->
  </div>
</template>

<script>
import { EVENT_GET_LIST } from '@/store/types'
import { isNiaMode } from '@/store/constants'
import { mapGetters } from 'vuex'
import BaseLocation from '../../components/base/BaseLocation.vue'
import EmptyData from '../../components/common/EmptyData.vue'
// import moment from 'moment'

export default {
  name: 'Events',
  components: { BaseLocation, EmptyData },

  data() {
    return {
      currentPage: 1,
      eventsPerPage: 10,
      search: 'CE', //'CE', 'PE'
      error: null,
      currentEvent: null,
      showDetail: false,
      isNiaMode
    }
  },
  computed: {
    ...mapGetters([
      'getEvents',
      'getEventTotalCount',
      'isSidebarOpen',
      'getCurrentUser'
    ]),
    formattedEvents() {
      if (!this.getEvents) return []
      const formatted = this.getEvents.map((evt) => {
        const formatDate = (dateStr) => {
          const date = new Date(dateStr)
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}.${month}.${day}`
        }

        return {
          ...evt,
          fromDtime: formatDate(evt.fromDtime),
          toDtime: formatDate(evt.toDtime)
        }
      })
      return formatted
    }
  },
  beforeRouteUpdate(to, from, next) {
    // console.log('routeupdate test~')
    // console.log(to)
    // console.log(from)
    if (!to.params.eventCd) {
      this.showDetail = false
      // console.log('in if~')
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      if (to.params.eventCd) {
        try {
          // console.log(to.params.eventCd)
          await vm.$store.dispatch(EVENT_GET_LIST, {
            search: 'ALL',
            page: 1,
            pageRow: 1,
            eventCd: to.params.eventCd
          })
          vm.currentEvent = vm.$store.getters.getEvents[0]
          vm.showDetail = true
          // next()
          return true
        } catch (err) {
          vm.loadEvents()
          next()
          return true
        }
      } else {
        vm.loadEvents()
        return true
      }
    })
  },
  mounted() {
    // this.loadEvents()
  },
  methods: {
    async loadEvents() {
      const { search, currentPage, eventsPerPage } = this
      try {
        await this.$store.dispatch(EVENT_GET_LIST, {
          search,
          page: currentPage,
          pageRow: eventsPerPage
        })
        this.$router
          .replace({
            path: '/events'
          })
          .catch(() => {})
      } catch (err) {
        this.error = err
        console.log(err)
      }
    },
    selectActiveTab(value) {
      this.search = value
      this.currentEvent = null
      this.showDetail = false
      this.currentPage = 1
      this.loadEvents()
    },
    paginate(page) {
      this.currentPage = page
      this.loadEvents()
    },
    showEventDetail(event) {
      if (event) {
        this.currentEvent = event
        this.$router.replace({
          params: {
            eventCd: event.eventCd
          }
        })
        this.showDetail = true
        return
      } else {
        this.$router.replace({
          params: {
            eventCd: null
          }
        })
        this.showDetail = false
      }
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
.event_item {
  width: 100%;
  height: 200px;
  padding: 18px;
  background: #f0f5fa;
  > .evnet_item_wrap {
    .event_image_wrap {
      overflow: hidden;
      width: 452px;
      height: 100%;
      flex: 0 0 auto;
      background-color: white;
      margin-right: 66px;
    }
    .event_meta_wrap {
      padding: 24px 0px;
      flex: 1 1 auto;
      .event_sub_desc {
        margin-top: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.cs_st .section .inner li > .evnet_item_wrap {
  display: flex;
}
@media (max-width: 768px) {
  .event_list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    .event_item {
      height: auto;
      padding: 20px 10px;
      > .evnet_item_wrap {
        .event_image_wrap {
          width: 100%;
          height: auto;
          margin-right: 0;
        }
        .event_meta_wrap {
          padding: 20px 0px 0;
          flex: 1 1 auto;
          .event_sub_desc {
            display: none;
          }
          .base_NR20 {
            font-size: 16px;
            font-weight: 500;
          }
          .evt_date {
            margin-top: 10px;
          }
          .base_MT14 {
            font-size: 10px;
            font-weight: 500;
          }
        }
      }
    }
  }

  .cs_st .section .inner li > .evnet_item_wrap {
    flex-direction: column;
  }
  .cs_st .event_list li + li {
    margin-top: 0;
  }
}
</style>
